import React from 'react';
import AddressBlock from '../../shared/AddressBlock';
import FileUploadField from '../../shared/FileUploadField';
import { CategoriaArquivo } from '@engenharia/shared';
import { useFormStore } from '../../../store/formStore';

interface Props {
  onUpload: (categoria: any, file: File) => void;
  onDelete: (id: number) => void;
  uploadStates: Record<string, { uploading: boolean; progress: number }>;
}

export default function EnderecoFaturamentoSection({ onUpload, onDelete, uploadStates }: Props) {
  const arquivos = useFormStore((s) => s.arquivos);

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-4">Endereço de Faturamento</h3>
      <AddressBlock prefix="endereco_faturamento" />
      <FileUploadField
        label="Comprovante de Endereço (Faturamento)"
        categoria={CategoriaArquivo.ComprovanteEnderecoFaturamento}
        arquivos={arquivos}
        uploading={uploadStates[CategoriaArquivo.ComprovanteEnderecoFaturamento]?.uploading || false}
        progress={uploadStates[CategoriaArquivo.ComprovanteEnderecoFaturamento]?.progress || 0}
        required
        onUpload={onUpload}
        onDelete={onDelete}
      />
      <FileUploadField
        label="Documento de Identidade"
        categoria={CategoriaArquivo.DocumentoIdentidade}
        arquivos={arquivos}
        uploading={uploadStates[CategoriaArquivo.DocumentoIdentidade]?.uploading || false}
        progress={uploadStates[CategoriaArquivo.DocumentoIdentidade]?.progress || 0}
        required
        onUpload={onUpload}
        onDelete={onDelete}
      />
    </div>
  );
}
